import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box } from "@mui/system";
import FilterComponent from "../../../../../../../../ReusableFIlterComponent/FilterComponent";
import {
  setSelectedAdGroupForIdenticalToExactKeyword,
  setSelectedCampaignForIdenticalToExactKeyword,
  setSelectedKeywordForIdenticalToExactKeyword,
} from "../../../../../../../../../features/searchTermTabSlice";

export default function IdenticalToExactKeywordFilterItems({
  clearSelectedSearchTerm,
}: any) {
  const {
    stIdenticalToExactKeyword,
    selectedCampaignForIdenticalToExactKeyword,
    selectedAdGroupForIdenticalToExactKeyword,
    selectedKeywordForIdenticalToExactKeyword,
  } = useSelector((state: any) => state.searchTermTab);

  const dispatch = useDispatch();

  const [searchAdgroups, setSearchAdgroups] = useState("");
  const [searchCampaigns, setSearchCampaigns] = useState("");
  const [searchKeywords, setSearchKeywords] = useState("");
  const filterConfig = [
    {
      key: "CampaignForIdenticalToExactKeyword",
      name: "Campaign",
      label: "Select one or more Campaigns",
      searchTerm: searchCampaigns,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchCampaigns(e.target.value),
      selectedOption: selectedCampaignForIdenticalToExactKeyword,
      filterName: "campaign_name",
      data: stIdenticalToExactKeyword,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(
          setSelectedCampaignForIdenticalToExactKeyword(updatedSelection)
        ),
      count:
        selectedCampaignForIdenticalToExactKeyword &&
        selectedCampaignForIdenticalToExactKeyword.length,
      colorSelected:
        selectedCampaignForIdenticalToExactKeyword !== null &&
        selectedCampaignForIdenticalToExactKeyword.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "AdgroupForIdenticalToExactKeyword",
      name: "Adgroup",
      label: "Select one or more Adgroups",
      searchTerm: searchAdgroups,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAdgroups(e.target.value),
      selectedOption: selectedAdGroupForIdenticalToExactKeyword,
      filterName: "adgroup_name",
      data: stIdenticalToExactKeyword,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(
          setSelectedAdGroupForIdenticalToExactKeyword(updatedSelection)
        ),
      count:
        selectedAdGroupForIdenticalToExactKeyword &&
        selectedAdGroupForIdenticalToExactKeyword.length,
      colorSelected:
        selectedAdGroupForIdenticalToExactKeyword !== null &&
        selectedAdGroupForIdenticalToExactKeyword.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "KeywordsForIdenticalToExactKeyword",
      name: "Keyword",
      label: "Select one or more Keywords",
      searchTerm: searchKeywords,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchKeywords(e.target.value),
      selectedOption: selectedKeywordForIdenticalToExactKeyword,
      filterName: "keyword_name",
      data: stIdenticalToExactKeyword,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(
          setSelectedKeywordForIdenticalToExactKeyword(updatedSelection)
        ),
      count:
        selectedKeywordForIdenticalToExactKeyword &&
        selectedKeywordForIdenticalToExactKeyword.length,
      colorSelected:
        selectedKeywordForIdenticalToExactKeyword !== null &&
        selectedKeywordForIdenticalToExactKeyword.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    dispatch(setSelectedCampaignForIdenticalToExactKeyword([]));
    dispatch(setSelectedAdGroupForIdenticalToExactKeyword([]));
    dispatch(setSelectedKeywordForIdenticalToExactKeyword([]));
    clearSelectedSearchTerm(null);
    setSearchAdgroups("");
    setSearchCampaigns("");
    setSearchKeywords("");
  };

  return (
    <Box data-tracker="563" sx={{ position: "relative" }}>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
}
